/**
 * Models a shard
 */

import Brace from "backbone.brace";
import Customer from "./shard-customer";

const Model = Brace.Model.extend({
  namedAttributes: {
    id: Number,
    description: String,
    datasourceJndiName: String,
    key: String,
    dbHost: String,
    dbPort: Number,
    dbUser: String,
    dbPass: String,
    dbSid: String,
    dbTnsName: String,
    skipDatabaseMigrations: Boolean,
    customer: Customer,
    // used by environment selection screen
    checked: Boolean,
  },
  defaults: {
    id: null,
    description: null,
    datasourceJndiName: null,
    key: null,
    dbHost: null,
    dbPort: null,
    dbUser: null,
    dbPass: null,
    dbSid: null,
    dbTnsName: null,
    skipDatabaseMigrations: false,
    customer: null,
    checked: false,
  },
});

export { Model as default };
